// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-green-gray[data-v-5797e823] {\r\n  background-color: #ebf1ee !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
